export default __webpack_public_path__ + "static/media/V124_CoC.883ee3aa.pdf";